if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				// the header action buttons are sized by the '.header-container' rules, so the cloned rows need that class too
				stickyHeader.innerHTML = `<div class="site-header header__top header-container hide-border-on-portable container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>
				<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
				</div>`;
				document.body.append(stickyHeader);

				stickyHeader.querySelectorAll('[data-js-focus-overlay]').forEach(elm=>{
					elm.dataset.jsFocusOverlay = `${elm.dataset.jsFocusOverlay}-sticky`;
				})
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				// the search overlay is fixed positioned, so it has to be closed together with the sticky header
				const hideStickyHeader = ()=>{
					stickyHeader.classList.remove('show');
					stickyHeader.querySelectorAll('.search-results-overlay.active').forEach(elm=>{
						elm.classList.remove('active');
					})
				}

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						hideStickyHeader();
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							hideStickyHeader();

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
								stickyHeader.classList.add('show');
							}

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							hideStickyHeader();
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				const alignSubmenu = ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				}
				elm.addEventListener('mouseover', alignSubmenu);
				elm.addEventListener('focusin', alignSubmenu);
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					// the overlay stays open while focus is inside the search (so Tab reaches the results)
					// and closes once focus moves elsewhere or on Escape

					const searchForm = elm.closest('search-form');
					const closeOverlay = ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay)?.classList.remove('active');
					}
					searchForm.addEventListener('focusin', e=>{
						// Shift+Tab can land on a result while the overlay is still fading out
						if ( e.target !== elm && searchForm.querySelector('[data-js-search-results]').contains(e.target) ) {
							document.getElementById(elm.dataset.jsFocusOverlay)?.classList.add('active');
						}
					})
					searchForm.addEventListener('focusout', e=>{
						// a click on a non-focusable part of the results has no relatedTarget, clicks outside hit the overlay itself
						if ( e.relatedTarget && ! searchForm.contains(e.relatedTarget) ) {
							closeOverlay();
						}
					})
					searchForm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.ESC && document.getElementById(elm.dataset.jsFocusOverlay)?.classList.contains('active') ) {
							closeOverlay();
							if ( e.target !== elm ) {
								elm.focus();
								// refocusing the input must not reopen the overlay
								closeOverlay();
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// Doofinder search layer: the app appends it to the end of <body>, so keyboard focus never reaches it
			// and it stays open while tabbing on. Tab from the search input moves into the layer, leaving the
			// layer (Tab on the last / Shift+Tab on the first element, Escape) closes it or returns to the input

			const tabbableSelector = 'a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
			const isTabbable = el=>el.matches(tabbableSelector) && el.tabIndex >= 0 && el.getClientRects().length && getComputedStyle(el).visibility != 'hidden';
			const getTabbables = scope=>[...scope.querySelectorAll(tabbableSelector)].filter(isTabbable);
			// page order including open shadow roots (e.g. the <shopify-account> button)
			const getPageTabbables = (root=document, list=[])=>{
				root.querySelectorAll('*').forEach(el=>{
					if ( isTabbable(el) ) list.push(el);
					if ( el.shadowRoot ) getPageTabbables(el.shadowRoot, list);
				});
				return list;
			}
			const getDoofinderLayer = ()=>[...document.querySelectorAll('.dfd-root')].find(layer=>getComputedStyle(layer).display != 'none' && layer.getClientRects().length);
			const closeDoofinderLayer = layer=>{
				layer?.querySelector('.dfd-close-button')?.click();
			}
			// Doofinder swallows the focus event of the input, so the input is remembered on keydown;
			// falls back to the visible search input (e.g. when the layer was opened by mouse)
			let lastSearchInput = null;
			const getSearchInput = ()=>lastSearchInput && lastSearchInput.getClientRects().length ? lastSearchInput : [...document.querySelectorAll('[data-js-search-input]')].find(input=>input.getClientRects().length);

			document.querySelectorAll('[data-js-search-input]').forEach(input=>{
				input.addEventListener('keydown', e=>{
					lastSearchInput = input;
					if ( e.keyCode != window.KEYCODES.TAB || e.shiftKey ) return;
					const layer = getDoofinderLayer();
					const layerTabbables = layer ? getTabbables(layer) : [];
					if ( layerTabbables.length ) {
						e.preventDefault();
						layerTabbables[0].focus();
					}
				});
				input.addEventListener('focusout', e=>{
					const layer = getDoofinderLayer();
					if ( layer && e.relatedTarget && ! layer.contains(e.relatedTarget) ) {
						closeDoofinderLayer(layer);
					}
				});
			});

			document.addEventListener('keydown', e=>{
				const layer = e.target.closest?.('.dfd-root');
				const searchInput = layer && getSearchInput();
				if ( ! searchInput ) return;
				if ( e.keyCode == window.KEYCODES.ESC ) {
					e.preventDefault();
					closeDoofinderLayer(layer);
					// Doofinder blurs on Escape itself, so the focus is restored afterwards
					// (Doofinder opens its layer again whenever the input gets focus)
					setTimeout(()=>searchInput.focus(), 50);
				} else if ( e.keyCode == window.KEYCODES.TAB ) {
					const layerTabbables = getTabbables(layer);
					if ( e.shiftKey && e.target === layerTabbables[0] ) {
						e.preventDefault();
						searchInput.focus();
					} else if ( ! e.shiftKey && e.target === layerTabbables[layerTabbables.length - 1] ) {
						// continue with the element that follows the search input in the page
						e.preventDefault();
						const pageTabbables = getPageTabbables().filter(el=>! el.closest('.dfd-root'));
						const next = pageTabbables[pageTabbables.indexOf(searchInput) + 1];
						// moving focus out of the layer closes it (see focusout below)
						next ? next.focus() : closeDoofinderLayer(layer);
					}
				}
			}, true);

			document.addEventListener('focusout', e=>{
				const layer = e.target.closest?.('.dfd-root');
				if ( layer && e.relatedTarget && ! layer.contains(e.relatedTarget) && ! e.relatedTarget.matches('[data-js-search-input]') ) {
					closeDoofinderLayer(layer);
				}
			});

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', ()=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:true });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', ()=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
						}
						babyMenuTouch = false;
					}, { passive:true });
				}
			})

			// tab navigation for the menu

			// the submenu opens while keyboard focus is inside the menu item, so Tab / Shift+Tab reach the sub links;
			// Enter on a real link keeps navigating, Escape closes the submenu and returns focus to the main link

			document.querySelectorAll('.site-nav.style--classic .has-submenu, .site-nav.style--classic .normal-menu .has-babymenu').forEach(elm=>{

				const toggle = elm.querySelector(':scope > .menu-link');
				if ( ! toggle ) return;

				const openMenu = ()=>{
					elm.classList.add('focus');
					elm.dataset.keyboardOpen = 'true';
					toggle.setAttribute('aria-expanded', 'true');
				}
				const closeMenu = ()=>{
					elm.classList.remove('focus');
					delete elm.dataset.keyboardOpen;
					toggle.setAttribute('aria-expanded', 'false');
				}

				elm.addEventListener('focusin', e=>{
					// mouse and touch focus keep the hover / touch behaviour
					if ( ! e.target.matches(':focus-visible') ) return;
					if ( elm.dataset.dismissed ) {
						if ( e.target === toggle ) return;
						delete elm.dataset.dismissed;
					}
					openMenu();
				});

				elm.addEventListener('focusout', e=>{
					if ( elm.contains(e.relatedTarget) ) return;
					delete elm.dataset.dismissed;
					if ( elm.dataset.keyboardOpen ) {
						closeMenu();
					}
				});

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.ESC && elm.classList.contains('focus') ) {
						e.stopPropagation();
						elm.dataset.dismissed = 'true';
						closeMenu();
						toggle.focus();
					} else if ( e.keyCode == window.KEYCODES.RETURN && e.target === toggle && toggle.tagName !== 'A' ) {
						// placeholder items without a link act as a button
						e.preventDefault();
						delete elm.dataset.dismissed;
						elm.classList.contains('focus') ? closeMenu() : openMenu();
					}
				});

				elm.openMenu = openMenu;

			});

			// Shift+Tab from a main link goes backwards through the submenu of the previous main item

			document.querySelectorAll('.site-nav.style--classic').forEach(nav=>{
				const topItems = [...nav.querySelectorAll('.link-list > li')];
				topItems.forEach((item, i)=>{
					const link = item.querySelector(':scope > .menu-link');
					const prevItem = topItems[i - 1];
					if ( ! link || ! prevItem || ! prevItem.openMenu ) return;
					link.addEventListener('keydown', e=>{
						if ( e.keyCode != window.KEYCODES.TAB || ! e.shiftKey ) return;
						prevItem.openMenu();
						const subLinks = [...prevItem.querySelectorAll('.submenu :is(a[href], button:not([disabled]), [tabindex="0"])')].filter(a=>getComputedStyle(a).visibility == 'visible' && a.getClientRects().length);
						if ( subLinks.length ) {
							e.preventDefault();
							subLinks[subLinks.length - 1].focus();
						}
					});
				});
			});

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > .menu-link').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > .menu-link').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}